import { css } from '@emotion/react';
import { getColor } from '@atlassiansox/wpl-utils';
export const indicatorStyle = css `
  display: flex;
  position: absolute;
  color: ${getColor('n0')};
  background-color: ${getColor('r500')};
  border-radius: 10px;
  height: 12px;
  min-width: 9px;
  padding: 0 3px;
  font-size: 8.5px;
  top: -5px;
  left: -9px;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=cart-icon.styles.js.map